import React from 'react';

const Header = () => {
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return (
    <section id="header" className='max-w-7xl mx-auto'>
      {/* Page content */}
      <div>
        {/* Date */}
        <div className="p-10 text-right text-xl font-light font-sans" id="dateContainer">
          {formattedDate}
        </div>
        <div className='flex flex-col justify-center items-center gap-4 pb-4'>

          {/* Green check mark */}
          <img
            src="https://sinoclear.net/order-confirmation/assets/check-mark.png"
            alt="green check mark"
            className="w-14"
            loading="lazy"
          />

          {/* Thank you message */}
          <h4 className="text-center text-[#132c4d] text-[47px] font-bold ">
            THANK YOU FOR YOUR ORDER
          </h4>

          <h2 className='lg:text-3xl md:text-2xl text-xl font-light text-center text-black mt-3 lg:leading-[60px]' >
            <span className='text-[#ff1300] font-bold'>IMPORTANT: </span>
            Your credit card statement will show a charge from <br /><span className='text-[#ff1300] font-bold'>CLKBANK*</span> <span className='font-light'>RESPOCLEAR</span> 
          </h2>
        </div>

      </div>
    </section>
  );
};

export default Header;
